// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   apiUrl: 'https://edry.giantleapsystems.com/ediaryApi',
   appVersion: "1.0.2",
  versionURL: "http://3.1.42.248/assets/version.json",
  // apiUrl: 'https://elevateaudit.in/ediaryApi'
  //apiUrl : 'http://3.1.42.248/ediaryMigrationApi'ng serve
  //apiUrl: 'http://3.1.42.248/ediaryMigrationIdentityApi'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
